import { render, staticRenderFns } from "./Cooperate.vue?vue&type=template&id=7dc71d1c&scoped=true&"
import script from "./Cooperate.vue?vue&type=script&lang=js&"
export * from "./Cooperate.vue?vue&type=script&lang=js&"
import style0 from "./Cooperate.vue?vue&type=style&index=0&id=7dc71d1c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dc71d1c",
  null
  
)

export default component.exports